#import "./confluence-reaction-fragment.graphql"

mutation DeleteCommentReaction(
  $contentId: String!
  $containerId: String!
  $containerType: ContainerType!
  $contentType: GraphQLReactionContentType!
  $emojiId: String!
) {
  deleteReaction(
    contentId: $contentId
    containerId: $containerId
    containerType: $containerType
    contentType: $contentType
    emojiId: $emojiId
  ) {
    ...SaveReactionResponseFragment
  }
}
